import { ErrorType, PDFData, TOCItem } from '@readcloud/data';
import { PDFDocumentProxy } from 'pdfjs-dist';
import { PDFFindController, PDFLinkService } from 'pdfjs-dist/web/pdf_viewer';
import React from 'react';
import { Rendition } from '../types/epubs';
import { FindController } from '../types/FindController';

export interface PDFTreeNode {
  title: string;
  bold: boolean;
  italic: boolean;
  /**
   * - The color in RGB format to use for
   * display purposes.
   */
  color: Uint8ClampedArray;
  dest: string | Array<any> | null;
  url: string | null;
  unsafeUrl: string | undefined;
  newWindow: boolean | undefined;
  count: number | undefined;
  items: any[];
}

export const DocumentWithExtrasContext = React.createContext<{
  setData: (data: PDFData) => void;
  setType: (type: string) => void;
  setPrepareError: (error: ErrorType) => void;
  setProgress: (progress: number) => void;
  setLocation: (
    location: string,
    rendition?: Rendition,
    endLocation?: string
  ) => void;
  setScale: (scale: number | ((prevState: number) => number)) => void;
  setTemporaryScale: (scale: number | ((prevState: number) => number)) => void;
  setElementOrigin: (
    origin:
      | { x: number; y: number }
      | ((prevState: { x: number; y: number }) => { x: number; y: number })
  ) => void;
  setScreenOrigin: (
    origin:
      | { x: number; y: number }
      | ((prevState: { x: number; y: number }) => { x: number; y: number })
  ) => void;

  setPreparingDocumentData: (preparingDocumentData: boolean) => void;
  setFindController: (findController: FindController) => void;
  setOutline: (outline: TOCItem[]) => void;
  data: PDFData;
  loading: boolean;
  type: string;
  progress: number;
  prepareError: ErrorType;
  pdfDocument: PDFDocumentProxy;

  error: ErrorType;
  extras:
    | {
        pdfFindController?: PDFFindController;
        linkService?: PDFLinkService;
        outline: TOCItem[];
        labels: { value: string; label: string }[];
      }
    | undefined;
  findController?: FindController;
  location: string;
  scale: number;
  temporaryScale: number;
  elementOrigin: { x: number; y: number };
  screenOrigin: { x: number; y: number };
}>({
  setData: undefined,
  setType: undefined,
  setProgress: undefined,
  setPrepareError: undefined,
  setLocation: undefined,

  setPreparingDocumentData: undefined,
  setFindController: undefined,
  setOutline: undefined,
  setScale: undefined,
  setTemporaryScale: undefined,
  setElementOrigin: undefined,
  setScreenOrigin: undefined,
  loading: false,
  data: undefined,
  pdfDocument: undefined,
  error: undefined,
  extras: undefined,
  findController: undefined,
  type: undefined,
  progress: undefined,
  prepareError: undefined,
  location: undefined,
  scale: 1,
  temporaryScale: 1,
  elementOrigin: { x: 0, y: 0 },
  screenOrigin: { x: 0, y: 0 },
});
